import TicketsScannerGroupedTicketItems from './GroupedTicketItems'

const TicketsScannerCrewMemberInfo = ({ crew_member, groupedTicketItems }) => {
  return (
    <div className="row">
      <div className="col-md-6">
        <h2>{crew_member.name}</h2>
        <p>{crew_member.email}</p>
        <p>
          <b>{I18n.t("tickets_scanner.owner_info.comment")}: </b>
          {crew_member.comment}
        </p>
        <p>
          <b>{I18n.t("tickets_scanner.owner_info.crew_list_group")}: </b>
          {crew_member.crew_list_group}
        </p>
        <p>
          <b>{I18n.t("tickets_scanner.owner_info.crew_list")}: </b>
          {crew_member.crew_list}
        </p>
      </div>
      <div className="col-md-6">
        {groupedTicketItems.length > 0 ? (
          <TicketsScannerGroupedTicketItems
            groupedTicketItems={groupedTicketItems}
          />
        ) : (
          ""
        )}
      </div>
    </div>
  )
}

export default TicketsScannerCrewMemberInfo
